<template>
  <div class="unsettled-orders">
    <base-status-orders
      :status="'UNSETTLED'"
      :title="'未结算订单'"
      :show-actions="true">
      <template #actions="{ row }">
        <el-button 
          type="primary" 
          size="mini" 
          @click="handleViewDetails(row)">查看详情</el-button>
        <el-button 
          type="success" 
          size="mini" 
          @click="handleSettle(row)">结算</el-button>
      </template>
    </base-status-orders>

    <!-- 结算对话框 -->
    <el-dialog
      title="订单结算"
      :visible.sync="settleDialogVisible"
      width="500px">
      <el-form 
        ref="settleForm" 
        :model="settleForm" 
        :rules="settleRules" 
        label-width="100px">
        <el-form-item label="订单金额" prop="amount">
          <el-input-number 
            v-model="settleForm.amount" 
            :precision="2" 
            :step="0.1" 
            :min="0"
            style="width: 100%">
          </el-input-number>
        </el-form-item>
        <el-form-item label="结算备注" prop="remark">
          <el-input
            type="textarea"
            v-model="settleForm.remark"
            :rows="3"
            placeholder="请输入结算备注信息">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="settleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSettle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BaseStatusOrders from './BaseStatusOrders.vue'
import { adminApi } from '@/api'

export default {
  name: 'UnsettledOrders',
  components: {
    BaseStatusOrders
  },
  data() {
    return {
      settleDialogVisible: false,
      currentOrder: null,
      settleForm: {
        amount: 0,
        remark: ''
      },
      settleRules: {
        amount: [
          { required: true, message: '请输入结算金额', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入结算备注', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleViewDetails(row) {
      // 跳转到订单详情页
      this.$router.push(`/admin/orders/detail/${row.id}`)
    },
    handleSettle(row) {
      this.currentOrder = row
      this.settleForm = {
        amount: row.amount || 0,
        remark: ''
      }
      this.settleDialogVisible = true
    },
    submitSettle() {
      this.$refs.settleForm.validate(async valid => {
        if (valid) {
          try {
            await adminApi.settleOrder({
              orderId: this.currentOrder.id,
              amount: this.settleForm.amount,
              remark: this.settleForm.remark
            })
            this.$message.success('结算成功')
            this.settleDialogVisible = false
            // 刷新订单列表
            this.$refs.baseStatusOrders.fetchOrders()
          } catch (error) {
            this.$message.error(error.message || '结算失败')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.unsettled-orders {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.settle-form {
  width: 100%;
}

.form-title {
  margin-bottom: 30px;
  color: #303133;
  font-size: 20px;
  text-align: center;
}

.form-card {
  width: 100%;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.form-card .el-card__header {
  padding: 15px 20px;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
}

.el-form-item {
  margin-bottom: 22px;
  width: 100%;
}

.el-input,
.el-select,
.el-date-picker,
.el-radio-group,
.el-upload,
.el-textarea {
  width: 100%;
}

/* 两列布局 */
.form-row {
  display: flex;
  justify-content: space-between;
  margin: 0 -10px;
}

.form-col {
  flex: 1;
  padding: 0 10px;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  min-width: 120px;
  margin: 0 10px;
}

/* 结算信息样式 */
.settle-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f9eb;
  border-radius: 4px;
}

.amount-input .el-input-number__decrease,
.amount-input .el-input-number__increase {
  background-color: #f5f7fa;
  color: #606266;
}

.amount-input .el-input__inner {
  text-align: center;
  font-weight: bold;
  color: #67c23a;
}

/* 备注文本域样式 */
.remark-textarea textarea {
  min-height: 120px;
  resize: vertical;
}

/* 结算历史记录样式 */
.settle-history {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.history-title {
  font-weight: bold;
  color: #606266;
  margin-bottom: 10px;
}

.history-item {
  padding: 10px;
  border-bottom: 1px solid #ebeef5;
}

.history-item:last-child {
  border-bottom: none;
}

.history-amount {
  color: #67c23a;
  font-weight: bold;
}

.history-time {
  color: #909399;
  font-size: 12px;
}
</style> 